import { Component, OnInit } from '@angular/core';
import { UserService } from '../_services/user.service';
import { Subscription, Observable } from 'rxjs';
import { AngularFirestore } from 'angularfire2/firestore';

@Component({
  selector: 'friend-request',
  templateUrl: './friend-request.component.html',
  styleUrls: ['./friend-request.component.css']
})
export class FriendRequestComponent implements OnInit {
  requests: Observable<any[]>;
  userId = this.userService.getUid();
  user: any;
  private subscription: Subscription = new Subscription();
  constructor(
    private afs: AngularFirestore,
    private userService: UserService) {

    this.requests = this.afs.collection('users').doc(this.userId).collection('friendRequests').valueChanges();
    this.subscription.add(this.userService.getUser().subscribe(data => {
      this.user = data;
    }))
  }

  async accept() {
    await this.afs.collection('users').doc(this.userId)
      .update({ followErCount: this.user.followErCount ? this.user.followErCount + 1 : 1 });
    await this.afs.collection('users').doc(this.userId).collection('friendRequests').ref.get().then((data => {
      let requestKey;
      data.forEach(snap => {
        requestKey = snap.id;

        this.afs.collection('users').doc(snap.data().userKey).ref.get().then((followCount => {
          this.afs.collection('users').doc(snap.data().userKey).update({
            followIngCount: followCount.data().followIngCount ?
              followCount.data().followIngCount + 1 : 1
          });
        })).then(() => {
          this.afs.collection('users').doc(snap.data().userKey).collection('followIng').doc(this.userId).set({
            firstname: this.user.firstname,
            lastname: this.user.lastname,
            email: this.user.email,
            username: this.user.username,
            profileImage: this.user.profileImage,
            type: "user",
            id: this.user.id

          })

        })
          .then(() => {
            this.afs.collection('users').doc(this.userId).collection('followEr').doc(snap.data().userKey).set({
              firstname: snap.data().firstname,
              lastname: snap.data().lastname,
              email: snap.data().email,
              username: snap.data().username,
              profileImage: snap.data().profileImage,
              type: "user",
              id: snap.id

            })

          }).then(() => {
            this.afs.collection('users').doc(this.userId).collection('requests').doc(snap.data().userKey).delete();
            this.afs.collection('users').doc(snap.data().userKey).collection('requests').doc(this.userId).delete();
          }).then(() => {
            this.afs.collection('users').doc(this.userId).collection('friendRequests').doc(requestKey).delete();
          })
      })
    }))
  }

  reject() {

    this.afs.collection('users').doc(this.userId).collection('friendRequests').ref.get().then((data) => {
      let requestKey;
      if (data) {
        data.forEach(snap => {
          requestKey = snap.id;
          this.afs.collection('users').doc(this.userId).collection('requests').doc(snap.data().userKey).set({ request: false }).then(() => {
            this.afs.collection('users').doc(snap.data().userKey).collection('requests').doc(this.userId).delete();
          }).then(() => {
            this.afs.collection('users').doc(this.userId).collection('friendRequests').doc(requestKey).delete();
          })
        })

      }

    })
  }

  ngOnInit() {
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/friend-request/friend-request.component.ts